import Login from "./screens/Login";
import {Colors} from "./colors";
import React, {useContext} from "react";
import AppConfigContext from "../../contexts/AppConfigContext";
import {useFonts} from "expo-font";
import {SnackBar} from "./components/SnackBar";
import {SafeAreaView, TouchableOpacity, View} from "react-native";
import {ProgressViewContext} from "../../contexts/ProgressViewContext";
import ProgressView from "./components/ProgressView";
import Menu from "./screens/Menu";
import Cart from "./screens/Cart";
import Delivery from "./screens/Delivery";
import AddressEditor from "./screens/AddressEditor";
import FontAwesome from "./components/FontAwesome";
import Text from "./components/Text";
import Overview from "./screens/Overview";
import CTCReceipt from "./screens/CTCReceipt";
import IPGCompletion from "./screens/IPGCompletion";
import NotificationAccessRequest from "./screens/NotificationAccessRequest";
import OrderProgress from "./screens/OrderProgress";
import Services from "./screens/Services";
import UserMenu from "./screens/UserMenu";
import ClientInfoEdit from "./screens/ClientInfoEdit";
import OrdersHistory from "./screens/OrdersHistory";
import Games from "./screens/Games";
import GameScreen from "./screens/GameScreen";
import BranchInfoScreen from "./screens/BranchInfoScreen";
import BranchWorkingTime from "./screens/BranchWorkingTime";
import AppNavigatorContainer from "../../components/handler-components/AppNavigatorContainer";
import TakeawayReceipt from "./screens/TakeawayReceipt";
import PWAInstallPrompt from "./screens/PWAInstallPrompt";
import GuestNotAllowed from "./screens/GuestNotAllowed";
import {AppFunctionsContext} from "../../contexts/AppFunctionsContext";

export default function Shayan(props: any) {

    ///////////// FONT
    const [loaded] = useFonts({
        IRANsans_ultralight: require('./assets/fonts/iransans/IRANSansXFaNum-UltraLight.ttf'),
        IRANsans_light: require('./assets/fonts/iransans/IRANSansXFaNum-Light.ttf'),
        IRANsans_thin: require('./assets/fonts/iransans/IRANSansXFaNum-Thin.ttf'),
        IRANsans: require('./assets/fonts/iransans/IRANSansXFaNum-Regular.ttf'),
        IRANsans_medium: require('./assets/fonts/iransans/IRANSansXFaNum-Medium.ttf'),
        IRANsans_bold: require('./assets/fonts/iransans/IRANSansXFaNum-Bold.ttf'),
        IRANsans_demibold: require('./assets/fonts/iransans/IRANSansXFaNum-DemiBold.ttf'),
        IRANsans_black: require('./assets/fonts/iransans/IRANSansXFaNum-Black.ttf'),
        IRANsans_extrabold: require('./assets/fonts/iransans/IRANSansXFaNum-ExtraBold.ttf'),
        fa_brands: require('./assets/fonts/fa/fa-brands-400.ttf'),
        fa_regular: require('./assets/fonts/fa/fa-regular-400.ttf'),
        fa_solid: require('./assets/fonts/fa/fa-solid-900.ttf')
    });
    
    const appConfigContext = useContext(AppConfigContext);
    const scheme = appConfigContext.theme;
    const colors = Colors.instanceNoServerColor(scheme, appConfigContext.color);

    const progressShow = useContext(ProgressViewContext).show;

    return <SafeAreaView style={{height: "100%", backgroundColor: colors.get("highConBackground") as string}}>
        <Header/>
        <AppNavigatorContainer pages={{
            menuPage: Menu,
            loginPage: Login,
            cartPage: Cart,
            deliveryPage: Delivery,
            addressEditorPage: AddressEditor,
            overViewPage: Overview,
            overProgressPage: OrderProgress,
            userMenuPage: UserMenu,
            ordersHistoryPage: OrdersHistory,
            gamePage: GameScreen,
            ctcReceiptModal: CTCReceipt,
            ipgCompletionModal: IPGCompletion,
            notificationAccessModal: NotificationAccessRequest,
            servicesModal: Services,
            clientInfoEditModal: ClientInfoEdit,
            gamesModal: Games,
            branchInfoModal: BranchInfoScreen,
            branchWorkingTimeModal: BranchWorkingTime,
            takeawayReceipt: TakeawayReceipt,
            pwaInstallPrompt: PWAInstallPrompt,
            guestNotAllowed: GuestNotAllowed
        }} darkTheme={colors.getNavigatorDarkTheme()} lightTheme={colors.getNavigatorLightTheme()}/>

        <ProgressView show={progressShow}/>
        <SnackBar data={appConfigContext.snackBarData?.data}/>
    </SafeAreaView>
}

function Header() {
    const config = useContext(AppConfigContext);
    const colors = Colors.instanceNoServerColor(config.theme, config.color);
    const appFunctions = useContext(AppFunctionsContext);
    const texts = config.texts;
    const title = config.currentPageTitle;
    return config.pageHasHeader ? <View style={{
        backgroundColor: colors.get("highConHeader") as string,
        margin: 8,
        padding: 9,
        flexDirection: "row",
        borderColor: colors.get("separator") as string,
        borderRadius:15,
        shadowOpacity: 0.1, 
        shadowRadius:4,
        shadowOffset:{height: 3,width: 3},
        height: 56
    }}>
        <TouchableOpacity onPress={() => {
            appFunctions.appNavigator.back();
        }}>
            <FontAwesome containerStyle={{
                justifyContent: "center",
                backgroundColor: colors.get("primaryColor"),
                borderRadius: 50,
                width: 36,
                height: 36
            }} color={"#fff"} icon={texts.t("icons.back")}/>
        </TouchableOpacity>
        <Text weight={600} style={{padding: 7, paddingHorizontal: 14}}>
            {title}
        </Text>
    </View> : <></>
}